import { Component, OnDestroy, OnInit } from '@angular/core';
import {RouterOutlet } from '@angular/router';
import { Subject, Subscription } from 'rxjs';
export let browserRefresh = false;


@Component({
    selector   : 'app-root',
    templateUrl: './app.component.html',
    styleUrls  : ['./app.component.scss'],
    standalone : true,
    imports    : [
        RouterOutlet, 
    ], 
})
export class AppComponent implements OnDestroy
{

    subscription: Subscription;
    private _unsubscribeAll: Subject<any> = new Subject<any>();
    /**
     * Constructor
     */
    constructor(){}


    ngOnDestroy(): void
    {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }
}

